// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zC00S","content":"styles_content__W+oB6"};